import store from '@/store'
const routes = [
  {
    path: '/',
    name: '',
    component: () => import('@/views/Propio/AppPropio'),
    meta: {
      logged: false,
      tucuenta: false,
      icon: 'mdi-basket'
    },
    /* beforeEnter: (to, from, next) => {
      console.log(to);
      console.log(from);
      const negocio = this.$route.params.negocio;
      if (!negocio) {
        this.$route("/");
      }
      alert("OasdfasfK");
    }, */
    children: [
      {
        path: '',
        name: '',
        component: () => import('@/views/Propio/HomePropio'),
        meta: {
          logged: false,
          tucuenta: false,
          icon: 'mdi-basket'
        },
      },
      /*{
        path: 'pedir',
        name: 'Pide Online',
        component: () => import('@/views/Propio/ElegirModoPropio'),
        meta: {
          logged: false,
          tucuenta: false,
          icon: 'mdi-basket'
        },
      },*/
      {
        path: 'pedir/recoger',
        name: 'Pide Online',
        component: () => import('@/views/Propio/RecogerPropio'),
        meta: {
          logged: false,
          tucuenta: false,
          icon: 'mdi-basket'
        },
        beforeEnter: (to, from, next) => {
          var vieneDePedir = (from.meta.zonaPedido) ? from.meta.zonaPedido : false;
          store.commit('direcciones/setVieneDePedidos', vieneDePedir)
          next();
        }
      },
      {
        path: 'pedir/domicilio',
        name: 'Pide Online',
        component: () => import('@/views/Propio/DomicilioPropio'),
        meta: {
          logged: false,
          tucuenta: false,
          icon: 'mdi-basket'
        },
      },
      {
        path: 'pedir/:modo/:rest',
        name: 'Pide Online',
        component: () => import('@/views/Propio/PedirPropio'),
        meta: {
          logged: false,
          tucuenta: false,
          icon: 'mdi-basket',
          zonaPedido: true
        },
      },
      {
        path: 'pedir/finalizar',
        name: 'Finaliza tu pedido',
        component: () => import('@/views/Propio/FinalizarPropio'),
        meta: {
        }
      },
      {
        path: 'tu-cuenta/formaspago',
        name: 'Formas de Pago',
        component: () => import('@/views/TuCuenta/FormasPago'),
        meta: {
          logged: true,
          tucuenta: true,
          icon: 'mdi-cards'
        }
      },
      {
        path: 'tu-cuenta/perfil',
        name: 'Perfil',
        component: () => import('@/views/Perfil'),
        meta: {
          logged: true,
          tucuenta: true,
          icon: 'mdi-account'
        }
      },
      {
        path: '/pedir/resumen-pedido',
        name: 'Resumen de tu pedido',
        component: () => import('@/views/Pedidos/resumenPedido'),
        meta: {
        }
      },
      {
        path: '/terminos-y-condiciones-de-uso',
        name: 'Términos y condiciones de uso',
        component: () => import('@/views/Propio/terminosYCondicionesPropio.vue'),
        meta: {
          logged: false,
          tucuenta: false,
          icon: 'mdi-basket'
        },
      },
      {
        path: '/politica-de-cookies',
        name: 'Política de cookies',
        component: () => import('@/views/Propio/politicaCookiesPropio.vue'),
        meta: {
          logged: false,
          tucuenta: false,
          icon: 'mdi-basket'
        },
      },
      {
        path: 'carta/:rest',
        name: 'Carta del restaurante',
        component: () => import('@/views/Propio/LaCarta'),
        meta: {
          logged: false,
          tucuenta: false,
          icon: 'mdi-basket'
        },
      },
    ]
  },
  {
    path: '/confirmarpago/',
    name: '',
    component: () => import('@/views/PagoConfirmado/'),
    meta: {
      logged: false,
      tucuenta: false,
      icon: 'mdi-basket'
    },
    children: [
      {
        path: '',
        name: '',
        component: () => import('@/views/Propio/HomePropio'),
        meta: {
          logged: false,
          tucuenta: false,
          icon: 'mdi-basket'
        },
      }
    ]
  },
  { path: "*", component: () => import('@/views/PageNotFound'), }
]

export { routes }